import styled from 'styled-components';
import { useMapStore, useUserRolePermissionStore } from 'contexts/RootStore.context';
import { ChangeEvent, useEffect } from 'react';
import { observer } from 'mobx-react';
import { CheckBox } from 'components/inputs/CheckBox/CheckBox';
import { Horizontal } from 'gls';
// import { DISPLAY_ASSET_NAME_LIMIT } from 'stores/MapStore';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #ffffff;
  height: 73px;
  width: 100%;
  padding: 25px;
  > span {
    margin-right: 9px;
  }
  .ant-checkbox-wrapper {
    &:nth-of-type(2) {
      margin-left: 12px;
    }
  }
`;

export const DisplaySetting = observer(() => {
  const { filterForm,
    // visibleAssetsCount, visibleUsersCount, visibleDevicesCount 
  } = useMapStore()
  const assetsSearchSelected = filterForm.$.searchTerm.value === ""
    || (filterForm.$.searchIn.value === 'assets' || filterForm.$.searchIn.value === "");
  const usersSearchSelected = filterForm.$.searchTerm.value === ""
    || (filterForm.$.searchIn.value === 'users' || filterForm.$.searchIn.value === "");
  const devicesSearchSelected = filterForm.$.searchTerm.value === ""
    || (filterForm.$.searchIn.value === 'devices' || filterForm.$.searchIn.value === "");
  console.log(filterForm.$.searchIn.value)
  const { canViewUsers, canViewAssets, canViewDevices } = useUserRolePermissionStore()

  function handleAssetMarkerInfoCheckboxToggle(ev: ChangeEvent<HTMLInputElement>) {
    const checked = ev.target.checked;
    filterForm.$.displayAssetName.onChange(checked)
  }

  function handleUsersMarkerInfoCheckboxToggle(ev: ChangeEvent<HTMLInputElement>) {
    const checked = ev.target.checked;
    filterForm.$.displayUserName.onChange(checked)
  }

  function handleDeviceMarkerInfoCheckboxToggle(ev: ChangeEvent<HTMLInputElement>) {
    const checked = ev.target.checked;
    filterForm.$.displayDeviceId.onChange(checked)
  }
  const showAssets = filterForm.$.show.value.includes("assets")
  const showUsers = filterForm.$.show.value.includes("users")
  const showDevices = filterForm.$.show.value.includes("devices")

  console.log(canViewDevices, showDevices, devicesSearchSelected)
  useEffect(() => {
    // set marker infochecked to false, whenever show assets or users is false.
    // this will ensure infoboxes are not displayed initially when show markers are toggled off, then on.
    if (!showAssets || !assetsSearchSelected) {
      filterForm.$.displayAssetName.onChange(false)
    }
    if (!showUsers || !usersSearchSelected) {
      filterForm.$.displayUserName.onChange(false)
    }
    if (!showDevices || !devicesSearchSelected) {
      filterForm.$.displayDeviceId.onChange(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetsSearchSelected, showAssets, showUsers, usersSearchSelected, showDevices, devicesSearchSelected]);

  return (
    <StyledDiv data-test-id="display-checkbox">
      <Horizontal>
        <span>Display:</span>
        {canViewAssets && showAssets && assetsSearchSelected && (
          <CheckBox
            value={1}
            name='show-asset-name-checkbox'
            id="show-asset-name-checkbox"
            checked={filterForm.$.displayAssetName.value}
            onChange={handleAssetMarkerInfoCheckboxToggle}
            label='Asset Name & Asset Type'
          // disabled={visibleAssetsCount > DISPLAY_ASSET_NAME_LIMIT}
          />
        )}
        {canViewUsers && showUsers && usersSearchSelected && (
          <CheckBox
            value={2}
            id="show-username-checkbox"
            name="show-username-checkbox"
            checked={filterForm.$.displayUserName.value}
            onChange={handleUsersMarkerInfoCheckboxToggle}
            label='Name'
          // disabled={visibleUsersCount > DISPLAY_ASSET_NAME_LIMIT}
          />
        )}
        {canViewDevices && showDevices && devicesSearchSelected && (
          <CheckBox
            value={2}
            id="show-deviceId-checkbox"
            name="show-deviceId-checkbox"
            checked={filterForm.$.displayDeviceId.value}
            onChange={handleDeviceMarkerInfoCheckboxToggle}
            label='Device ID'
          // disabled={visibleDevicesCount > DISPLAY_ASSET_NAME_LIMIT}
          />
        )}
      </Horizontal>
    </StyledDiv>
  );
})